module.exports = __webpack_public_path__ + "static/media/buttetin_format_10.50ffdb83.png";